export default "__VITE_ASSET__c3d7af09__"